import PropTypes from 'prop-types';
import React from 'react';
import ReactSelect, { components } from 'react-select';
import styled from 'styled-components';

import Icon from '../../../deprecated/icon';
import { COLORS } from '../../../tokens/colors';
import { Menu, MenuList, Option as BigOption, SmallOption } from '../dropdown';

const ControlTitle = styled.div`
    cursor: pointer;
`;
const Control = (props) => {
    const { children, isDisabled, isFocused, innerRef, innerProps } = props;
    return (
        <ControlTitle ref={innerRef} isFocused={isFocused} isDisabled={isDisabled} {...innerProps} >
            {children}
        </ControlTitle>
    );
};

const ValueContainer = styled(components.ValueContainer)`
    padding: 0!important;
    flex: auto!important;
    align-items: flex-start!important;
`;

const TitleValue = styled.div`
    color: ${COLORS.TextPrimary};
`;
const SingleValue = (props) => {
    const { children, isDisabled, innerRef, innerProps } = props;
    return (
        <TitleValue ref={innerRef} isDisabled={isDisabled} {...innerProps} >
            {children}
        </TitleValue>
    );
};

const Indicator = styled(components.DropdownIndicator)`
    min-width: 20px;
    justify-content: center;
    align-items: center;
    margin-left: 5px;
    padding: 0!important;
`;
const DropdownIndicator = (props) => {
    return (
        <Indicator {...props} >
            <Icon content='\e653' color={COLORS.TextPrimary} />
        </Indicator>
    );
};

export default class Select extends React.Component {
    static propTypes = {
        options: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.any,
            value: PropTypes.any,
        })),
        defaultValue: PropTypes.any,
        placeholder: PropTypes.string,
        onChange: PropTypes.func,
        value: PropTypes.shape({
            label: PropTypes.any,
            value: PropTypes.any,
        }),
    };

    static defaultProps = {
        options: [],
        placeholder: '',
        onChange: () => { },
    };

    onChange = (value) => {
        this.props.onChange(value);
    };

    render() {
        const { options, defaultValue, value, placeholder, minWidth, extStyle, smallOption, ...rest } = this.props;

        const Option = (props) => smallOption ? <SmallOption fontSize='14px' {...props} /> : <BigOption {...props}/>;
        const customComponents = {
            IndicatorSeparator: null,
            Control,
            ValueContainer,
            SingleValue,
            Option,
            Menu,
            MenuList,
            DropdownIndicator,
        };

        const customStyles = {
            menu: base => ({
                ...base,
                minWidth: minWidth,
            }),
            ...extStyle,
        };
        return (
            <ReactSelect
                options={options}
                onChange={this.onChange}
                defaultValue={defaultValue}
                value={value}
                isClearable={false}
                isSearchable={false}
                placeholder={placeholder}
                components={customComponents}
                styles={customStyles}
                {...rest}
            />
        );
    }
}
